import Link from "next/link";
import { useRouter } from "next/router";
import { fetchCMSDocument, getGlobalData } from "utils/api";
import { getLocalizedPaths } from "utils/localize";

import { RefreshHeader } from "@/components/brandRefresh/common/PageTemplate";
import Document from "@/components/brandRefresh/document";

const ButtonLink = ({ href, text, active }) => (
  <Link
    href={href}
    className={`w-full font-medium text-base 4xl:text-xl text-center bg-onmoPurple-50 hover:outline ${
      active ? "outline" : ""
    } outline-2 outline-onmoPrimary text-onmoPrimary px-4 py-3 rounded-lg`}
  >
    {text}
  </Link>
);

const buttons = [
  {
    href: "/legal/privacy-policy/onmo-limited-privacy-policy",
    text: "Onmo Limited Privacy Policy",
  },
  {
    href: "/legal/privacy-policy/personal-information-we-collect",
    text: "Personal Information We Collect",
  },
  {
    href: "/legal/privacy-policy/tpl-privacy-policy",
    text: "TPL Privacy Policy",
  },
  {
    href: "/legal/privacy-policy/open-banking-privacy-notice",
    text: "Open Banking Notice",
  },
];

function Terms({ metadata, mdxData }) {
  const { asPath } = useRouter();

  return (
    <>
      <RefreshHeader metadata={metadata}>
        <div className="flex flex-col text-sm md:text-base">
          <div className="grid lg:grid-cols-2 grid-cols-1 gap-6">
            {buttons.map(({ href, text }) => (
              <ButtonLink
                key={href}
                href={href}
                text={text}
                active={href === asPath.split("?")[0]}
              />
            ))}
          </div>
          <div className="md:pt-spacing-14 pt-spacing-12">
            <Document data={mdxData} />
          </div>
        </div>
      </RefreshHeader>
    </>
  );
}

export async function getServerSideProps(context) {
  const { params, locale, locales, defaultLocale } = context;
  const globalLocale = await getGlobalData(locale);

  const { slug } = params;
  const mdxData = await fetchCMSDocument(slug);

  if (mdxData === null || mdxData === undefined) {
    return {
      notFound: true,
    };
  }

  const pageContext = {
    locale,
    locales,
    defaultLocale,
    slug: context.resolvedUrl.replace(/\//g, ""),
  };

  const localizedPaths = getLocalizedPaths(pageContext);

  const metadata = {
    metaTitle: `Privacy Policy`,
  };

  return {
    props: {
      metadata,
      global: globalLocale.data,
      mdxData,
      pageContext: {
        ...pageContext,
        localizedPaths,
      },
    },
  };
}

export default Terms;
